import React from "react";
import Carousel from "react-material-ui-carousel";
import { Paper } from "@material-ui/core";
import { MEDIA_TYPE } from "../../utils/AppEnumerations";
import ICImage from "../../core-component/ICImage";
import VideoPlayer from "../../components/common/VideoPlayer";
import ICPureImage from "../../core-component/ICPureImage";
interface ICarouselItem {
  media_url: string;
  media_type: string;
  media_title?: string;
}

interface ICarouselProps {
  items: ICarouselItem[];
}

interface ICustomCarouselProps extends ICarouselProps {
  animation?: "slide" | "fade";
  timeout?: number;
  indicators?: boolean;
  navButtonsAlwaysInvisible?: boolean;
}

const PublicCarousel: React.FC<ICustomCarouselProps> = ({
  items,
  animation = "slide",
  timeout = 1500,
  indicators = false,
  navButtonsAlwaysInvisible = true,
}) => {
  const carouselSettings = {
    animation,
    timeout,
    indicators,
    navButtonsAlwaysInvisible,
  };
  const filteredItems =
    items &&
    items.length > 0 &&
    items.filter((item) => item.media_type !== MEDIA_TYPE.pdf);
  return (
    <Carousel animation="slide" autoPlay={true}>
      {filteredItems &&
        filteredItems.length > 0 &&
        filteredItems.map((item, index) => (
          <Paper key={index}>
            <div key={index} className="flex justify-center h-full w-full">
              {item.media_type === MEDIA_TYPE.video ? (
                <div>
                  <VideoPlayer
                    control={[
                      "play",
                      "progress",
                      "current-time",
                      "mute",
                      "fullscreen",
                      "volume",
                      "play-large",
                    ]}
                    source={item.media_url}
                  />
                </div>
              ) : (
                <ICPureImage
                  imageUrl={item.media_url}
                  wrapperClassName="h-full w-full aspect-16/9"
                  className="aspect-16/9  w-full"
                  alt={`carousel-item-${index}`}
                />
              )}
            </div>
          </Paper>
        ))}
    </Carousel>
  );
};

export default PublicCarousel;
